import * as dayjs from "dayjs";

export interface ICartaoCredito {
  id?: number;
  token?: string | null;
  dataCriacao?: dayjs.Dayjs | null;
  name?: string | null;
  tipodocumento?: string | null;
  documento?: string | null;
  primeirosdigitos?: string | null;
  ultimosdigitos?: string | null;
  expiration_year?: number | null;
  expiration_month?: number | null;
  payment_id?: string | null;
  bandeira?: string | null;
}

export class CartaoCredito implements ICartaoCredito {
  constructor(public id?: number,
    public token?: string | null,
    public dataCriacao?: dayjs.Dayjs | null,
    public name?: string | null,
    public tipodocumento?: string | null,
    public documento?: string | null,
    public primeirosdigitos?: string | null,
    public ultimosdigitos?: string | null,
    public expiration_year?: number | null,
    public expiration_month?: number | null,
    public payment_id?: string | null,
    public bandeira?: string | null
  ) { }
}

export function getCartaoCreditoIdentifier(cartaoCredito: ICartaoCredito): number | undefined {
  return cartaoCredito.id;
}
